import axios from "../axios-instance";
import { notification } from "./utility";

/**
 * Start Google/Outlook calendar OAuth via authenticated one-time ticket.
 * Prefer this over raw google-calendar-auth / outlook-calendar-auth hrefs.
 *
 * @param {{ businessId: number|string, provider: 'google'|'outlook', owner?: 'admin'|'staff', selectAccount?: boolean }} opts
 * @returns {Promise<void>}
 */
export async function startCalendarOAuth({
  businessId,
  provider,
  owner = "admin",
  selectAccount = false,
}) {
  if (!businessId) {
    notification.error("Missing business for calendar connect.");
    return;
  }
  if (provider !== "google" && provider !== "outlook") {
    notification.error("Unknown calendar provider.");
    return;
  }

  try {
    const res = await axios.post("/admin/calendar-oauth-ticket", {
      business_id: Number(businessId),
      provider,
      owner: owner === "staff" ? "staff" : "admin",
      select_account: !!selectAccount,
    });
    const url = res?.data?.data?.url || res?.data?.url;
    if (!url) {
      notification.error("Could not start calendar connect. Please try again.");
      return;
    }
    window.location.href = url;
  } catch (err) {
    const msg =
      err?.response?.data?.message ||
      err?.response?.data?.error ||
      "Could not start calendar connect.";
    notification.error(msg);
  }
}
